import React from 'react';
import {Upload} from 'components/forms/sections';
import {Route} from 'react-router-dom';
import {
    Signature,
    ShipmentDischarge,
    NatureOfVoyage,
    RatingFactory,
} from './sections';
import ProgressForm from 'components/forms/ProgressForm';
// use this to pass document_
import {Branch, BranchGroup} from 'components/forms/navigation';
import {FormNames, FormTypes} from '../../../constants';
import {StatePrompt} from 'components/forms';
import getVesselInForm from '../vessel/VesselInForm';

const FormCod = () => {
    const node = FormTypes.COD.toLowerCase();

    const isNotOffshore = state => {
        return state && state?.vessel_type !== 'Offshore';
    };

    const isOffshore = state => {
        return state && state?.vessel_type === 'Offshore';
    };

    const Rating = RatingFactory();
    const RatingOffshore = RatingFactory(true);

    return (
        <ProgressForm title={FormNames.COD} node={node}>
            <StatePrompt />
            <Route path={`/forms/${node}/upload`}>
                <Upload documentType={node} />
            </Route>
            <Route path={`/forms/${node}/signature`}>
                <Signature />
            </Route>
            <Route path={`/forms/${node}/shipment`}>
                <ShipmentDischarge />
            </Route>
            {getVesselInForm(node)}
            <BranchGroup key='offshore'>
                <Branch when={isNotOffshore}>
                    <Route path={`/forms/${node}/rating`}>
                        <Rating />
                    </Route>
                </Branch>
                <Branch when={isOffshore}>
                    <Route path={`/forms/${node}/offshore-rating`}>
                        <RatingOffshore />
                    </Route>
                </Branch>
            </BranchGroup>
            <Route path={`/forms/${node}/nature-of-voyage`}>
                <NatureOfVoyage />
            </Route>
        </ProgressForm>
    );
};

export default FormCod;
